import { CodeSnippet, CodeSnippetGroup } from '../../administration/models';
import { CompileDummyCodeType } from '../../rules/types';
import appClient from '../../common/services/AppClient';
import { ResultApi } from '../../common/services/AppClient';
import { endpoints } from '../../../config';

export default class BusinessRulesService {
    executeBusinessRuleCode(code: string, compileDummyCodeType?: CompileDummyCodeType): Promise<ResultApi<unknown>> {
        const request = {
            code: code
        };
        const url = `${endpoints.manageUrl}business_rules/compile/${compileDummyCodeType}`;
        return appClient.post(url, request);
    }

    executeBusinessRuleQuery(connectionId: string, query: string): Promise<ResultApi<unknown>> {
        const request = {
            connectionId: connectionId,
            query: query
        };

        const url = endpoints.manageUrl + 'business_rules/execute-query';
        return appClient.post(url, request);
    }

    async getCodeSnippets(): Promise<CodeSnippet[] | null> {
        const url = `${endpoints.manageUrl}code_snippets`;
        const result = await appClient.get<CodeSnippet[]>(url);
        return result.match(
            value => value,
            () => null
        );
    }

    async getCodeSnippetGroups(): Promise<CodeSnippetGroup[] | null> {
        const url = `${endpoints.manageUrl}code_snippet_groups`;
        const result = await appClient.get<CodeSnippetGroup[]>(url);
        return result.match(
            value => value,
            () => null
        );
    }
}
